import {
  Component,
  OnInit,
  Injectable,
  Input,
  EventEmitter,
  ViewChild,
  ComponentFactoryResolver,
  Injector,
  ViewContainerRef,
  HostListener,
} from "@angular/core";
import { ModalController, MenuController, IonContent } from "@ionic/angular";
import { ModalPage } from "src/app/modals/modal/modal.page";
import { promise } from "protractor";
import { ChangeDetectorRef, ElementRef } from "@angular/core";
import { Router } from "@angular/router";
import { TutorialVidsComponent } from "../tutorialVideos/tutorialVids.component";
import { TutorialVidsService } from "../tutorialVideos/tutorialVids.service";
import { AppService } from "src/app/app.service";
import { FormPage } from "src/app/form/form.page";
import { Global } from "src/global";

export interface AppPage {
  title: string;
  url: string;
  icon: string;
  menuItem: boolean;
}

@Component({
  selector: "app-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
})
@Injectable({
  providedIn: "root",
})
export class ModalComponent implements OnInit {
  @ViewChild("componentContainer", { read: ViewContainerRef })
  componentContainer: ViewContainerRef;
  tutorialVideos: any[] = [];

  @Input() someData: string;
  @ViewChild(IonContent, { static: true }) content: IonContent;
  sections: string[] = [
    "Introduction",
    "Training",
    "Users",
    "Lessons",
    "Content",
    // "Contractors",
    "Visitors",
    "Settings",
    "Reports",
    "Resources",
  ];
  currentSectionIndex: number = 0;
  selectedTab: string = "menuPage";
  selectedComponent: any;
  selectedMenuItemTitle: string = "Home";

  appHeaderEmitter: EventEmitter<string> = new EventEmitter();
  selectedPage: AppPage;

  constructor(
    public globals: Global,
    public modalController: ModalController,
    private menuCtrl: MenuController,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private viewContainerRef: ViewContainerRef,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private elementRef: ElementRef,
    private appservice: AppService,
    private tutorialVidsService: TutorialVidsService
  ) {}

  scrollToNextSection() {
    this.currentSectionIndex++;
    const nextSectionId = this.sections[this.currentSectionIndex];
    const yOffset = document.getElementById(nextSectionId).offsetTop;
    this.content.scrollToPoint(0, yOffset, 0);
  }

  scrollToPrevious() {
    if (this.currentSectionIndex > 0) {
      this.currentSectionIndex--;
      const previousSectionId = this.sections[this.currentSectionIndex];
      const yOffset = document.getElementById(previousSectionId).offsetTop;
      this.content.scrollToPoint(0, yOffset, 0);
    }
  }
  scrollToTop() {
    this.content.scrollToTop(0);
    this.currentSectionIndex = 0;
  }

  scrollToSection(sectionId: string) {
    const yOffset = document.getElementById(sectionId).offsetTop;
    this.content.scrollToPoint(0, yOffset, 0);
  }

  onScroll(event) {
    const scrollPosition = event.detail.scrollTop;
    let currentIndex = 0;
    for (let i = 0; i < this.sections.length; i++) {
      const sectionElement = document.getElementById(this.sections[i]);
      if (sectionElement.offsetTop <= scrollPosition) {
        currentIndex = i;
      } else {
        break;
      }
    }
    this.currentSectionIndex = currentIndex;
  }

  ionViewDidEnter() {
    const currentUrl = window.location.href;

    if (currentUrl.includes("/training")) {
      this.selectedMenuItemTitle = "Training";
    } else if (
      currentUrl.includes("/users") ||
      currentUrl.includes("/peopleSimplified") ||
      currentUrl.includes("/importPeople") ||
      currentUrl.includes("/peopleGroups") ||
      currentUrl.includes("/end-session")
    ) {
      this.selectedMenuItemTitle = "Users";
    } else if (
      currentUrl.includes("/lessons") ||
      // currentUrl.includes("/media") ||
      currentUrl.includes("/assignments") ||
      currentUrl.includes("/procedure") ||
      currentUrl.includes("/qualifications") ||
      currentUrl.includes("/siteAssignment") ||
      currentUrl.includes("/lesson-builder")
    ) {
      this.selectedMenuItemTitle = "Lessons";
    } else if (currentUrl.includes("/manage-content")) {
      this.selectedMenuItemTitle = "Content";
    } else if (
      currentUrl.includes("/resource-manager") ||
      currentUrl.includes("/contractor") ||
      currentUrl.includes("/people?") ||
      currentUrl.includes("/race") ||
      currentUrl.includes("/housingStatus") ||
      currentUrl.includes("/workArea") ||
      currentUrl.includes("/mineRentalType") ||
      currentUrl.includes("/workSchedule") ||
      currentUrl.includes("/village") ||
      currentUrl.includes("/regions") ||
      currentUrl.includes("/distributionList") ||
      currentUrl.includes("/sow")
    ) {
      this.selectedMenuItemTitle = "Contractors";
    } else if (currentUrl.includes("/visitors")) {
      this.selectedMenuItemTitle = "Visitors";
    } else if (
      currentUrl.includes("/administration") ||
      currentUrl.includes("/report") ||
      currentUrl.includes("/userMetrics") ||
      currentUrl.includes("/lessonMetrics") ||
      currentUrl.includes("/siteMetrics") ||
      currentUrl.includes("/groupMetrics")
    ) {
      this.selectedMenuItemTitle = "Reports";
    } else if (
      currentUrl.includes("/profile") ||
      currentUrl.includes("/title") ||
      currentUrl.includes("/license") ||
      currentUrl.includes("/pricePlan") ||
      currentUrl.includes("/subscription") ||
      currentUrl.includes("/configuration") ||
      currentUrl.includes("/datalists") ||
      currentUrl.includes("/site") ||
      currentUrl.includes("/jobTitle") ||
      currentUrl.includes("/department")
    ) {
      this.selectedMenuItemTitle = "Settings";
    } else if (currentUrl.includes("/resources")) {
      this.selectedMenuItemTitle = "Resources";
    } else {
      this.selectedMenuItemTitle = "";
    }
    const sectionIndex = this.sections.findIndex(
      (section) =>
        section.toLowerCase() === this.selectedMenuItemTitle.toLowerCase()
    );

    if (sectionIndex !== -1) {
      this.currentSectionIndex = sectionIndex;
      const sectionId = this.sections[this.currentSectionIndex];
      const element = this.elementRef.nativeElement.querySelector(
        `#${sectionId}`
      );
      if (element) {
        const yOffset = element.offsetTop;
        this.content.scrollToPoint(0, yOffset, 0);
      }
    }
    this.selectedTab = "menuPage";
  }

  ngOnInit() {
    const sectionIndex = this.sections.findIndex(
      (section) =>
        section.toLowerCase() === this.selectedMenuItemTitle.toLowerCase()
    );

    if (sectionIndex !== -1) {
      const sectionId = this.sections[sectionIndex];
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
    this.loadTutorialVideos();
  }

  loadTutorialVideos(): void {
    const formData: FormData = new FormData();
    formData.append("User_GUID", this.globals.XRSUser.GUID);
    formData.append("User_Token", this.globals.XRSUser.UserToken);

    this.appservice.GetTutorialVideoList().subscribe((res) => {
      try {
        this.tutorialVideos = JSON.parse(res);
      } catch (e) {
        console.error(e);
      }
    });
  }

  mouseenter(event: any, url: string) {
    event.target.src = url;
  }

  mouseleave(event: any, url: string) {
    event.target.src = url;
  }

  navigateToURL(url: string) {
    this.router.navigate([url], {
      queryParams: { displayState: "normal", navigatedFromLink: "/resources" },
      replaceUrl: true,
    });
  }

  async tutorialVid(videoTitle: string) {
    const video = this.tutorialVideos.find((v) => v.Title === videoTitle);
    const modal = await this.modalController.create({
      component: TutorialVidsComponent,
      cssClass: "modal-fullscreen",
      componentProps: {
        videoData: video,
      },
    });
    await modal.present();
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  async show(
    modalType: string,
    modalHeaderText: string,
    modalBodyText: string
  ) {
    var promise = new Promise(async (resolve, reject) => {
      var paramObject = {
        modalType: modalType.toLowerCase(),
        modalHeaderText: modalHeaderText,
        modalBodyText: modalBodyText,
      };

      const modal = await this.modalController.create({
        component: ModalPage,
        componentProps: {
          paramObject: paramObject,
        },
        cssClass: "modals",
      });

      modal.onDidDismiss().then(async (dataReturned) => {
        resolve(dataReturned);
      });
      modal.present();
    });
    return promise;
  }
}
